if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.product__description');
        this.checkbox = this.querySelector('.product__description-checkbox');
        this.label = this.querySelector('.product__description-toggle');
        if (!this.content || !this.checkbox || !this.label) return;
        this.update = this.update.bind(this);
        this.checkbox.addEventListener('change', this.update);
        window.addEventListener('resize', this.update);
        window.addEventListener('load', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
        window.removeEventListener('load', this.update);
      }

      update() {
        if (this.checkbox.checked) return;
        const content = this.content;
        content.style.maxHeight = '';
        const top = content.getBoundingClientRect().top;
        const limit = top + content.clientHeight;
        const range = document.createRange();
        range.selectNodeContents(content);
        let cut = 0;
        for (const rect of range.getClientRects()) {
          if (rect.height > 0 && rect.bottom <= limit + 1 && rect.bottom - top > cut) cut = rect.bottom - top;
        }
        if (cut > 0) content.style.maxHeight = `${Math.ceil(cut)}px`;
        this.label.hidden = content.scrollHeight <= content.clientHeight + 2;
      }
    }
  );
}
